import * as React from "react";
import type { SVGProps } from "react";
const SvgIconRentStabilized = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      d="M8 14.9c3.81 0 6.9-3.09 6.9-6.9S11.8 1.1 8 1.1 1.1 4.2 1.1 8 4.2 14.9 8 14.9"
      fill="#EFFEFB"
    />
    <path
      d="M8 14.9c3.81 0 6.9-3.09 6.9-6.9S11.8 1.1 8 1.1 1.1 4.2 1.1 8 4.2 14.9 8 14.9"
      stroke="#04C8B4"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.8 6.11q-.09-.26-.27-.47c-.26-.29-.64-.47-1.06-.47h-1.1c-.7 0-1.26.57-1.26 1.26 0 .6.42 1.11 1 1.24l1.66.36c.65.14 1.12.72 1.12 1.38 0 .79-.64 1.42-1.42 1.42h-.94c-.62 0-1.14-.4-1.34-.94"
      stroke="#04C8B4"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5.17V3.75"
      stroke="#04C8B4"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12.25v-1.42"
      stroke="#04C8B4"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIconRentStabilized;
